import React from "react";
import useMediaQueries from "../../../../hooks/useMediaQueries.js";
import AnimationContainer from "../../../Reusable/AnimationContainer/AnimationContainer.js";
import Icon from "../../../Elements/Icon/Icon.tsx";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import ShareComponent from "../../../Reusable/SideBar/Share/ShareSideComponent.js";
import SecuritySettings from "./SecuritySettings.js";
import PaymentSettings from "./PaymentSettings.js";
import PropTypes from "prop-types";
import bytesToDisplayHelper from "../../../../utils/bytesToDisplayHelper.js";
import { removeStatuses } from "../helpers.js";
import { LogModal } from "../Embed/LogModal.js";

const MobileBottomInfoComponent = ({ data }) => {
  const { getTextByKey } = useContent();
  const size = bytesToDisplayHelper(data.filesSize);

  return (
    <div className="info-inbox-wrapper">
      <div className="info-header">
        <Icon name="folder" gray />
        <div className="subject-title">{data.subject}</div>
      </div>
      <div className="info-files">
        {data.filesQuantity} {getTextByKey("sidebar-info-files")}
      </div>
      <div className="info-size">{size.size + size.type}</div>
      <div className="info-downloads">
        {data.downloadsQuantity} {getTextByKey("sidebar-info-downloads")}
      </div>
    </div>
  );
};

const MobileBottomMenu = ({ showSideBar, setShowSideBar }) => {
  const { getTextByKey } = useContent();

  const mailActionsList = [
    {
      icon: "info",
      action: () => {
        setShowSideBar({ name: "info", data: showSideBar.data });
      },
    },
    {
      icon: "share-solid",
      action: () => {
        setShowSideBar({ name: "share", data: showSideBar.data });
      },
    },
    {
      icon: "jumbopay",
      action: () => {
        setShowSideBar({ name: "jumbopay", data: showSideBar.data });
      },
    },
    {
      icon: "alock",
      action: () => {
        setShowSideBar({ name: "alock", data: showSideBar.data });
      },
    },
  ];

  const contentEnum = {
    share: <ShareComponent mailData={showSideBar.data} />,
    info: <MobileBottomInfoComponent data={showSideBar.data} />,
    alock: <SecuritySettings data={showSideBar.data} />,
    jumbopay: <PaymentSettings data={showSideBar.data} />,
    alog: <LogModal deliveryNumber={showSideBar.data.deliveryNumber} />,
  };

  const headerNameKeysEnum = {
    share: "share-mail-title",
    info: "sidebar-info-header",
    alock: "security-settings-modal-title",
    jumbopay: "payment-settings-modal-title",
    alog: "actions-log-title",
  };

  return (
    <div className="inbox-mobile-mail-menu">
      <div className="menu-header">
        {getTextByKey(headerNameKeysEnum[showSideBar.name])}
        <Icon
          name="x"
          darkGray
          onClick={() => {
            setShowSideBar({ data: false });
          }}
        />
      </div>
      <div className="menu-content">{contentEnum[showSideBar.name]}</div>
      <div className="flex-spacer"></div>
      {!removeStatuses.includes(showSideBar.data.mailStatus) ? (
        <div className="menu-footer">
          {mailActionsList.map((item) => {
            const isCurrent = () => {
              if (
                showSideBar.name === item.icon ||
                (showSideBar.name === "share" && item.icon === "share-solid")
              ) {
                return true;
              }
              return false;
            };
            return (
              <Icon
                name={item.icon}
                darkGray={!isCurrent()}
                blue={isCurrent()}
                key={item.icon}
                onClick={item.action}
              />
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

MobileBottomMenu.propTypes = {
  showSideBar: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      data: {},
      name: PropTypes.string.isRequired,
    }),
  ]),
};

const MenuHolder = ({ showSideBar, setShowSideBar }) => {
  const { mobileCondition } = useMediaQueries();
  return mobileCondition ? (
    <AnimationContainer
      animationOn={showSideBar && !!showSideBar.data}
      animationClassName="side-bar-animation"
    >
      <MobileBottomMenu {...{ showSideBar, setShowSideBar }} />
    </AnimationContainer>
  ) : null;
};

export default MenuHolder;
